import { useFormContext } from 'react-hook-form';
import { FORM_FIELDS, PAGE } from '../../../../../constants';
import { useCarBrands } from '../../../../../store/reducers/dictionaries';
import { PURPOSE_SOURCE_VALUES } from '../../../../../constants/sources';
import { anyOptionValue } from '../../../ui/suggest/auto';
import { useCarModels } from '../../../../hooks/carModels';
import { useEffect } from 'react';
import { validateFields } from '../../../../../helpers/form.new';
import { getValidationSchema } from '../../../common.validators';
import { SignInParams } from '../../../../../services/identity/identity.types';

export const useAutoFieldsManager = () => {
    const form = useFormContext();

    const {
        watch,
        formState: { dirtyFields: _ },
        setValue,
    } = form;

    const [selectedPurpose, autoBrand, autoModel, autoBrandId, autoModelId] = watch([
        FORM_FIELDS.PURPOSE,
        FORM_FIELDS.AUTO_BRAND,
        FORM_FIELDS.AUTO_MODEL,
        FORM_FIELDS.AUTO_BRAND_ID,
        FORM_FIELDS.AUTO_MODEL_ID,
    ]);

    const brands = useCarBrands();
    const autoBrandsOptions = brands.map(({ name, id: value }) => ({ name, value: value.toString() }));

    const autoModelIsNeeded = Boolean(autoBrandId && autoBrandId !== anyOptionValue);
    const autoYearIsNeeded = Boolean(
        selectedPurpose === PURPOSE_SOURCE_VALUES.USED_CAR && autoModel && autoModel !== anyOptionValue,
    );

    const { autoModelsOptions, modelsIsLoading, yearsIsLoading, autoYearsOptions } = useCarModels(
        autoBrandId,
        autoModelId,
    );

    useEffect(() => {
        if (autoBrand && !autoBrandId) {
            const brandId = (autoBrandsOptions.find((item) => item.name === autoBrand) || { value: '' }).value;
            setValue(FORM_FIELDS.AUTO_BRAND_ID, brandId);
        }
        if (autoModel && !autoModelId && autoModelsOptions.length) {
            const modelId = (autoModelsOptions.find((item) => item.name === autoModel) || { value: '' }).value;
            setValue(FORM_FIELDS.AUTO_MODEL_ID, modelId);
        }
    }, [autoBrand, autoModel, autoModelsOptions]);

    return {
        autoModelIsNeeded,
        autoYearIsNeeded,

        modelsIsLoading,
        yearsIsLoading,

        autoBrandsOptions,
        autoModelsOptions,
        autoYearsOptions,
    };
};

export const validatePhone = async (phone: string) => {
    return await validateFields(getValidationSchema([FORM_FIELDS.PHONE]), {
        [FORM_FIELDS.PHONE]: phone,
    });
};

export const getSignInParams = (phone: string, page: ValuesOf<typeof PAGE>): SignInParams => {
    const customer = [PAGE.WHITELABEL, PAGE.AVITO].includes(page)
        ? 'Партнерская программа'
        : [PAGE.AGENTS].includes(page)
        ? 'Агентский кабинет'
        : 'Сайт';
    return {
        phone: phone.replace(/\D/g, ''),
        customer,
        productName: 'Подбор кредита',
    };
};
